import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.find";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/ui/colortableview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import ColorTileView from '@ckeditor/ckeditor5-ui/src/colorgrid/colortileview';
import ColorGridView from '@ckeditor/ckeditor5-ui/src/colorgrid/colorgridview';
import LabelView from '@ckeditor/ckeditor5-ui/src/label/labelview';
import DocumentColorCollection from "../documentcolorcollection";
import Template from '@ckeditor/ckeditor5-ui/src/template';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from '@ckeditor/ckeditor5-ui/src/focuscycler';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import removeButtonIcon from '@ckeditor/ckeditor5-core/theme/icons/eraser.svg';
import "../../theme/fontcolor.css";
/**
 * A class which represents a view with the following sub–components:
 *
 * * A remove color button,
 * * A static {@link module:ui/colorgrid/colorgrid~ColorGridView} of colors defined in the configuration,
 * * A dynamic {@link module:ui/colorgrid/colorgrid~ColorGridView} of colors used in the document.
 *
 * @extends module:ui/view~View
 */

var ColorTableView = /*#__PURE__*/function (_View) {
  _inherits(ColorTableView, _View);

  var _super = _createSuper(ColorTableView);

  /**
   * Creates a view to be inserted as a child of {@link module:ui/dropdown/dropdownview~DropdownView}.
   *
   * @param {module:utils/locale~Locale} [locale] The localization services instance.
   * @param {Object} config The configuration object.
   * @param {Array.<module:ui/colorgrid/colorgrid~ColorDefinition>} config.colors An array with definitions of colors to
   * be displayed in the table.
   * @param {Number} config.columns The number of columns in the color grid.
   * @param {String} config.removeButtonLabel The label of the button responsible for removing the color.
   * @param {String} config.documentColorsLabel The label for the section with the document colors.
   * @param {String} config.documentColorsCount The number of colors in the document colors section inside the color dropdown.
   */
  function ColorTableView(locale, _ref) {
    var _this;

    var colors = _ref.colors,
        columns = _ref.columns,
        removeButtonLabel = _ref.removeButtonLabel,
        documentColorsLabel = _ref.documentColorsLabel,
        documentColorsCount = _ref.documentColorsCount;

    _classCallCheck(this, ColorTableView);

    _this = _super.call(this, locale);
    /**
     * A collection of the children of the table.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.items = _this.createCollection();
    /**
     * An array with objects representing colors to be displayed in the grid.
     *
     * @type {Arrray.<module:ui/colorgrid/colorgrid~ColorDefinition>}
     */

    _this.colorDefinitions = colors;
    /**
     * Tracks information about the DOM focus in the list.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */

    _this.focusTracker = new FocusTracker();
    /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */

    _this.keystrokes = new KeystrokeHandler();
    /**
     * Keeps the value of the command associated with the table for the current selection.
     *
     * @type {String}
     */

    _this.set('selectedColor');
    /**
     * The label of the button responsible for removing color attributes.
     *
     * @type {String}
     */


    _this.removeButtonLabel = removeButtonLabel;
    /**
     * The number of columns in the color grid.
     *
     * @type {Number}
     */

    _this.columns = columns;
    /**
     * A collection of definitions that store the document colors.
     *
     * @readonly
     * @member {module:font/documentcolorcollection~DocumentColorCollection}
     */

    _this.documentColors = new DocumentColorCollection();
    /**
     * The maximum number of colors in the document colors section.
     * If it equals 0, the document colors section is not added.
     *
     * @readonly
     * @type {Number}
     */

    _this.documentColorsCount = documentColorsCount;
    /**
     * Preserves the reference to {@link module:ui/colorgrid/colorgrid~ColorGridView} used to create
     * the default (static) color set.
     *
     * @readonly
     * @member {module:ui/colorgrid/colorgrid~ColorGridView}
     */

    _this.staticColorsGrid = _this._createStaticColorsGrid();
    /**
     * Preserves the reference to {@link module:ui/colorgrid/colorgrid~ColorGridView} used to create
     * the document colors. It remains undefined if the document colors feature is disabled.
     *
     * @readonly
     * @member {module:ui/colorgrid/colorgrid~ColorGridView}
     */

    _this.documentColorsGrid;
    /**
     * Helps cycling over focusable {@link #items} in the list.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */

    _this._focusCycler = new FocusCycler({
      focusables: _this.items,
      focusTracker: _this.focusTracker,
      keystrokeHandler: _this.keystrokes,
      actions: {
        // Navigate list items backwards using the Arrow Up key.
        focusPrevious: 'arrowup',
        // Navigate list items forwards using the Arrow Down key.
        focusNext: 'arrowdown'
      }
    });

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-color-table']
      },
      children: _this.items
    });

    _this.items.add(_this._removeColorButton());

    _this.items.add(_this.staticColorsGrid);

    if (documentColorsCount) {
      // Create a label for document colors.
      var bind = Template.bind(_this.documentColors, _this.documentColors);
      var label = new LabelView(_this.locale);
      label.text = documentColorsLabel;
      label.extendTemplate({
        attributes: {
          class: ['ck', 'ck-color-grid__label', bind.if('isEmpty', 'ck-hidden')]
        }
      });

      _this.items.add(label);

      _this.documentColorsGrid = _this._createDocumentColorsGrid();

      _this.items.add(_this.documentColorsGrid);
    }

    return _this;
  }
  /**
   * Scans through the editor model and searches for text node attributes with the given attribute name.
   * Found entries are set as document colors.
   *
   * All the previously stored document colors will be lost in the process.
   *
   * @param {module:engine/model/model~Model} model The model used as a source to obtain the document colors.
   * @param {String} attributeName Determines the name of the related model's attribute for a given dropdown.
   */


  _createClass(ColorTableView, [{
    key: "updateDocumentColors",
    value: function updateDocumentColors(model, attributeName) {
      var document = model.document;
      var maxCount = this.documentColorsCount;
      this.documentColors.clear();

      var _iterator = _createForOfIteratorHelper(document.getRootNames()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rootName = _step.value;
          var root = document.getRoot(rootName);
          var range = model.createRangeIn(root);

          var _iterator2 = _createForOfIteratorHelper(range.getItems()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var node = _step2.value;

              if (node.is('textProxy') && node.hasAttribute(attributeName)) {
                this._addColorToDocumentColors(node.getAttribute(attributeName));

                if (this.documentColors.length >= maxCount) {
                  return;
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Refreshes the state of the selected color in one or both {@link module:ui/colorgrid/colorgrid~ColorGridView}s
     * available in the {@link module:font/ui/colortableview~ColorTableView}. It guarantees that the selection will occur only in one
     * of them.
     */

  }, {
    key: "updateSelectedColors",
    value: function updateSelectedColors() {
      var documentColorsGrid = this.documentColorsGrid;
      var staticColorsGrid = this.staticColorsGrid;
      var selectedColor = this.selectedColor;
      staticColorsGrid.selectedColor = selectedColor;

      if (documentColorsGrid) {
        documentColorsGrid.selectedColor = selectedColor;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ColorTableView.prototype), "render", this).call(this); // Items added before rendering should be known to the #focusTracker.


      var _iterator3 = _createForOfIteratorHelper(this.items),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          this.focusTracker.add(item.element);
        } // Start listening for the keystrokes coming from #element.

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this.keystrokes.listenTo(this.element);
    }
    /**
     * Focuses the first focusable element in {@link #items}.
     */

  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
    /**
     * Focuses the last focusable element in {@link #items}.
     */

  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
    /**
     * Adds the remove color button as a child of the current view.
     *
     * @private
     * @returns {module:ui/button/buttonview~ButtonView}
     */

  }, {
    key: "_removeColorButton",
    value: function _removeColorButton() {
      var _this2 = this;

      var buttonView = new ButtonView();
      buttonView.set({
        withText: true,
        icon: removeButtonIcon,
        tooltip: true,
        label: this.removeButtonLabel
      });
      buttonView.class = 'ck-color-table__remove-color';
      buttonView.on('execute', function () {
        _this2.fire('execute', {
          value: null
        });
      });
      return buttonView;
    }
    /**
     * Creates a static color table grid based on the editor configuration.
     *
     * @private
     * @returns {module:ui/colorgrid/colorgrid~ColorGridView}
     */

  }, {
    key: "_createStaticColorsGrid",
    value: function _createStaticColorsGrid() {
      var colorGrid = new ColorGridView(this.locale, {
        colorDefinitions: this.colorDefinitions,
        columns: this.columns
      });
      colorGrid.delegate('execute').to(this);
      return colorGrid;
    }
    /**
     * Creates the document colors section view and binds it to {@link #documentColors}.
     *
     * @private
     * @returns {module:ui/colorgrid/colorgrid~ColorGridView}
     */

  }, {
    key: "_createDocumentColorsGrid",
    value: function _createDocumentColorsGrid() {
      var _this3 = this;

      var bind = Template.bind(this.documentColors, this.documentColors);
      var documentColorsGrid = new ColorGridView(this.locale, {
        columns: this.columns
      });
      documentColorsGrid.delegate('execute').to(this);
      documentColorsGrid.extendTemplate({
        attributes: {
          class: bind.if('isEmpty', 'ck-hidden')
        }
      });
      documentColorsGrid.items.bindTo(this.documentColors).using(function (colorObj) {
        var colorTile = new ColorTileView();
        colorTile.set({
          color: colorObj.color,
          hasBorder: colorObj.options && colorObj.options.hasBorder
        });

        if (colorObj.label) {
          colorTile.set({
            label: colorObj.label,
            tooltip: true
          });
        }

        colorTile.on('execute', function () {
          _this3.fire('execute', {
            value: colorObj.color
          });
        });
        return colorTile;
      }); // Selected color should be cleared when document colors became empty.

      this.documentColors.on('change:isEmpty', function (evt, name, val) {
        if (val) {
          documentColorsGrid.selectedColor = null;
        }
      });
      return documentColorsGrid;
    }
    /**
     * Adds a given color to the document colors list. If possible, the method will attempt to use
     * data from the {@link #colorDefinitions} (label, color options).
     *
     * @private
     * @param {String} color A string that stores the value of the recently applied color.
     */

  }, {
    key: "_addColorToDocumentColors",
    value: function _addColorToDocumentColors(color) {
      var predefinedColor = this.colorDefinitions.find(function (definition) {
        return definition.color === color;
      });

      if (!predefinedColor) {
        this.documentColors.add({
          color: color,
          label: color,
          options: {
            hasBorder: false
          }
        });
      } else {
        this.documentColors.add(Object.assign({}, predefinedColor));
      }
    }
  }]);

  return ColorTableView;
}(View);

export { ColorTableView as default };